export default "__VITE_ASSET__BAyiez12__"